export class CopyUserRolesRequest {
    sampleUserId: number;
    targetUserId: number;
} 